// extracted by mini-css-extract-plugin
export var dividerLine = "_82-3";
export var itemImage = "_82-9";
export var lightDivider = "_82-4";
export var modalContent = "_82-5";
export var modalContentCompact = "_82-6";
export var productCard = "_82-a";
export var productImage = "_82-b";
export var productImageCompact = "_82-7";
export var productImagePlaceholder = "_82-c";
export var productImagePlaceholderCompact = "_82-8";
export var progressBarBackground = "_82-1";
export var progressBarContainer = "_82-0";
export var progressBarFill = "_82-2";